import axios from '../axios'

// 自分の成績・進捗（受験結果 + モジュール進捗）
const getGradesApi = async () => {
  return await axios.get('api/lms/grades')
}

export default getGradesApi
